module.exports = __webpack_public_path__ + "images/category_lp/pc/media2_316a2137e9524cc340d2653a82d7b52d.jpg";